import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../Styles/VerifyCodeAgency.css'; // optional CSS

const VerifyCodeAgency = () => {
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const location = useLocation();

  const email = location.state?.email;

  if (!email) {
    return <p>Error: Email not provided</p>;
  }

  const handleVerifyCode = async (e) => {
    e.preventDefault();

    if (code.length !== 6) {
      setError('Code must be 6 digits');
      return;
    }

    try {
      const response = await axios.post(
        'https://b2bbackend.dxbhabibi.com/api/b2/agency/verifyOTP',
        { email, code },
        { headers: { 'Content-Type': 'application/json' } }
      );

      if (response.status === 200) {
        alert('Code verified successfully!');
        navigate('/admin-reset-password', { state: { email } }); // navigate to reset page
      } else {
        setError('Invalid verification code');
      }
    } catch (err) {
      console.error(err);
      setError('Invalid or expired code');
    }
  };

  const handleResendVerificationCode = async () => {
    try {
      const response = await axios.post(
        'https://b2bbackend.dxbhabibi.com/api/b2/agency/resetVerifyCode',
        { email },
        { headers: { 'Content-Type': 'application/json' } }
      );

      if (response.status === 200) {
        alert('Verification code resent!');
        setError('');
      } else {
        setError('Failed to resend verification code');
      }
    } catch (err) {
      console.error(err);
      setError('Resend failed');
    }
  };

  return (
    <div className="verify-container">
      <div className="verify-card">
        <h2>Admin Verify Code</h2>
        <form onSubmit={handleVerifyCode}>
          <div className="form-group">
            <label>Enter 6-digit verification code</label>
            <input
              type="text"
              maxLength={6}
              value={code}
              onChange={(e) => setCode(e.target.value)}
              required
            />
          </div>

          {error && <p className="error-text">{error}</p>}

          <button type="submit" className="green-btn">Verify</button>
          <button type="button" className="blue-btn" onClick={handleResendVerificationCode}>
            Resend Verification Code
          </button>
        </form>
      </div>
    </div>
  );
};

export default VerifyCodeAgency;
